/**
 * MobileTabBar — bottom tab bar for the authenticated app shell. Keeps the
 * three primary destinations reachable on mobile without a hamburger menu.
 */

import React from "react";
import { Link } from "react-router-dom";
import { Compass, BookMarked, PenTool } from "lucide-react";
import { cx } from "@/components/site/primitives";

const TABS = [
  { key: "explore", label: "Explore", to: "/app/explore", icon: Compass },
  { key: "bookshelf", label: "Bookshelf", to: "/app/bookshelf", icon: BookMarked },
  { key: "studio", label: "Studio", to: "/app/studio", icon: PenTool },
];

export default function MobileTabBar({ activeKey }) {
  return (
    <nav
      aria-label="Primary"
      data-testid="mobile-tab-bar"
      className="fixed inset-x-0 bottom-0 z-40 flex items-stretch justify-around border-t border-line bg-card/95 pb-[env(safe-area-inset-bottom)] backdrop-blur-xl md:hidden"
    >
      {TABS.map(({ key, label, to, icon: Icon }) => {
        const isActive = key === activeKey;
        return (
          <Link
            key={key}
            to={to}
            data-testid={`mobile-nav-${key}`}
            aria-current={isActive ? "page" : undefined}
            className="flex flex-1 flex-col items-center justify-center gap-1 py-2.5 text-[11px] font-medium"
          >
            <Icon className={cx("h-5 w-5 transition-colors", isActive ? "text-coral" : "text-subtle")} />
            <span className={cx("transition-colors", isActive ? "font-semibold text-coral" : "text-subtle")}>{label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
